import axios, { AxiosRequestConfig, AxiosResponse, AxiosPromise } from "axios"
import { parseServerError } from "./errorService"
import { settings } from "../clientAppSettings"
import { RequestConfig } from "./../store/thunks/serverThunks"
import { logInfo } from "./../util/logUtil"
import { THttpMethod } from "../type/api/apiDocTypes"

export async function serverServiceExecuteRequest<T>(
    method: THttpMethod,
    url: string,
    config?: AxiosRequestConfig,
    requestConfig?: RequestConfig
): Promise<T> {
    const conf = config || {}
    try {
        let headers: any = conf.headers
        const contentType = conf.data instanceof FormData ? "multipart/form-data" : "application/json"
        switch (method) {
            case "get":
                break
            case "post":
                headers = {
                    "Content-Type": contentType,
                    ...conf.headers,
                }
                break
            case "put":
                headers = {
                    "Content-Type": contentType,
                    ...conf.headers,
                }
                break
            case "delete":
                headers = {
                    "Content-Type": contentType,
                    ...conf.headers,
                }
                break
            default:
                throw new Error("HttpMethod not supported: " + method)
        }
        if (settings.logServerRequests) {
            logInfo(method, url, conf.params, conf.data)
        }
        const response: AxiosResponse<T> = await axios({
            ...conf,
            method,
            headers,
            url,
        })
        if (!response) {
            throw new Error("No response")
        }

        const responseData = response.data as T
        if (settings.logServerResponses) {
            logInfo(method, url, responseData)
            logInfo(JSON.stringify(responseData))
        }
        return responseData
    } catch (error) {
        logInfo("Request failed:", url, conf, error)
        const serverError = parseServerError(error, requestConfig ? requestConfig.defaultErrorMessage : undefined)
        throw serverError
    }
}
